<template>
  <div>
    <v-list-item
      v-if="showed"
      two-line
      @click="showInfo"
    >
      <v-list-item-avatar>
        <v-icon class="primary white--text">{{typeLocalized.icon}}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="expanded">{{itemTitle}}</v-list-item-title>
        <v-list-item-subtitle
            v-html="itemNote"
            class="expanded html-subtitle"
        ></v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="canCopy">
        <v-btn
            color="accent"
            icon
            @click="copy"
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-divider v-if="needDivider"></v-divider>
  </div>
</template>

<script>
import {types} from '@/constants'
import {getPaymentInfoTitle, replaceToBr} from '@/services/utils'

export default {
  name: 'BuyoutPaymentInfoListItem',
  computed: {
    itemTitle () {
      return getPaymentInfoTitle(this.item)
    },
    itemNote () {
      return replaceToBr(this.item.note)
    },
    showed () {
      return this.buyout.paymentInfosMode === 'self' || this.item.active
    },
    typeLocalized () {
      return types.paymentInfo[this.item.type]
    }
  },
  created() {
    this.canCopy = this.item.type !== types.paymentInfo.cash.id
  },
  data () {
    return {
      canCopy: true
    }
  },
  methods: {
    copy (ev) {
      ev.stopPropagation()
      this.$emit('copy', this.item)
    },
    showInfo (event) {
      this.$emit('openDialog', {
        event,
        opt: {
          canCopy: this.canCopy,
          origin: this.item,
          title: this.itemTitle,
          note: this.itemNote,
          typeLocalized: this.typeLocalized
        }
      })
    }
  },
  props: {
    buyout: {
      required: true,
      type: Object
    },
    item: {
      required: true,
      type: Object
    },
    needDivider: {
      required: true,
      type: Boolean
    }
  }
}
</script>

<style scoped>

</style>